import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBMUpdXaqI8Vg9E3Se963dvQhRehJ9PFI0",
  authDomain: "ezri-meim.firebaseapp.com",
  projectId: "ezri-meim",
  storageBucket: "ezri-meim.appspot.com",
  messagingSenderId: "297701922194",
  appId: "1:297701922194:web:40adc902b18c376cb21d4b",
  measurementId: "G-MF1NSVVWRP"
};

// require('dotenv').config({'path':'./'});

// console.log("process=",process.env);

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_API_KEY,
//   authDomain: process.env.REACT_APP_AUTH_DOMAIN,
//   projectId: process.env.REACT_APP_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
//   appId: process.env.REACT_APP_APP_ID,
// };

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db }; // Export functions along with auth and db
